export const horizontalNavBarDataHooks = {
  root: 'horizontal-nav-bar',
  item: (key: string) => `horizontal-nav-bar-item-${key}`,
  sideContent: 'horizontal-nav-bar-side-content',
  scrollArrow: (direction: 'back' | 'forward') =>
    `horizontal-nav-bar-scroll-arrow-${direction}`,
};
